import React from 'react';
import PropTypes from 'prop-types';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import { CTAButton } from 'shared-components/buttons/cta-button';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

class PaymentErrorModal extends React.Component {
  render () {
    const { errorMsg, toggleModal } = this.props;
    const errorHeader = errorMsg.errorHead || <FormattedMessage id="inbox_guest_update_booking.payment_error_modal.something_wrong" defaultMessage="Something went wrong" />;
    const errorBodyFirstPart = errorMsg.errorBody || <FormattedMessage id="inbox_guest_update_booking.try_again" defaultMessage="Please try again." />;

    return (
      <BootstrapModal
        {...this.props}
        body={
          <div className="text-center">
            <p>
              <FormattedMessage
                id="inbox_guest_update_booking.payment_error_modal.cancel"
                defaultMessage="{firstPart} More information about the likely cause for this error can be found in our {supportLink}."
                values={{
                  firstPart: errorBodyFirstPart,
                  supportLink: <a href="https://support.peerspace.com/hc/articles/360031059811-Why-did-my-credit-card-get-declined-" target="_blank" rel="noopener noreferrer" className="underline"> <FormattedMessage id='inbox_guest_update_booking.error_support_link' defaultMessage='support center' /></a>
                }}
              />
            </p>
          </div> }
        modalSize="sm-size"
        modalClass="payment-error-modal"
        header={ <h3>{ errorHeader }</h3> }
        footer={
          <CTAButton
            buttonText={ this.props.intl.formatMessage({ id: 'inbox_guest_update_booking.payment_error_modal.okay', defaultMessage: 'Okay' }) }
            classNameString="btn btn-primary form"
            onClickAction={ () => { toggleModal(''); } }
            isDisabled={ false }
          />
        }
      />
    );
  }
}

PaymentErrorModal.propTypes = {
  errorMsg: PropTypes.object,
  toggleModal: PropTypes.func,
  intl: intlShape
};

exports.PaymentErrorModal = injectIntl(PaymentErrorModal);
